// extracted by mini-css-extract-plugin
export var colorSquare = "_n5-0";
export var container = "_n5-h";
export var danger = "_n5-5";
export var lightPink = "_n5-8";
export var neutralBlue = "_n5-7";
export var neutralYellow = "_n5-6";
export var normal = "_n5-1";
export var primary = "_n5-2";
export var primaryLight = "_n5-3";
export var selected = "_n5-i";
export var solidBlack = "_n5-g";
export var solidGreen = "_n5-b";
export var solidLightBlue = "_n5-d";
export var solidNavy = "_n5-c";
export var solidOrange = "_n5-f";
export var solidPink = "_n5-e";
export var solidRed = "_n5-9";
export var solidYellow = "_n5-a";
export var success = "_n5-4";